"use client";

import { set3D, use3DMode } from "@/lib/threeDMode";

const CUBE_FACES = [
  "rotateY(0deg)",
  "rotateY(90deg)",
  "rotateY(180deg)",
  "rotateY(270deg)",
  "rotateX(90deg)",
  "rotateX(-90deg)",
];

// Header switch for the home page's 3D mode. The little cube spins while 3D
// is on (CSS: .fx-mini-cube under html[data-3d]).
export default function ThreeDToggle({ className = "" }: { className?: string }) {
  const on = use3DMode();
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label="3D mode"
      title={on ? "Switch to the flat page" : "Switch on 3D mode"}
      onClick={() => set3D(!on)}
      className={`inline-flex h-11 flex-shrink-0 items-center gap-2 rounded-full bg-white pl-3 pr-1.5 text-[13px] font-semibold text-[#0b0f19] shadow-[0_6px_18px_-10px_rgba(15,23,42,0.5)] ring-1 ring-slate-200 transition hover:ring-slate-300 dark:bg-white/10 dark:text-white dark:ring-white/15 dark:hover:ring-white/30 ${className}`}
    >
      <span aria-hidden="true" className="relative h-3.5 w-3.5 [perspective:60px]">
        <span className="fx-mini-cube absolute inset-0">
          {CUBE_FACES.map((face, i) => (
            <span
              key={face}
              className={`absolute inset-0 rounded-[2px] border ${
                on
                  ? i % 2
                    ? "border-emerald-500 bg-emerald-300/70"
                    : "border-sky-500 bg-sky-300/70"
                  : "border-slate-400 bg-white/60 dark:border-slate-400 dark:bg-white/10"
              }`}
              style={{ transform: `${face} translateZ(7px)` }}
            />
          ))}
        </span>
      </span>
      3D
      <span
        aria-hidden="true"
        className={`relative h-6 w-10 rounded-full transition-colors ${
          on ? "bg-gradient-to-r from-emerald-400 via-sky-400 to-violet-500" : "bg-slate-200 dark:bg-white/15"
        }`}
      >
        <span
          className={`absolute left-0 top-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform ${
            on ? "translate-x-[18px]" : "translate-x-0.5"
          }`}
        />
      </span>
    </button>
  );
}
